export default "__VITE_ASSET__Bk3T6mhh__"